import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useViewType } from '../../../../hooks/useViewType';

import { PLAYBOOK_BUILDER_MODE } from '../../../../constants/playbookBuilder';

import { ListOption, ListOptionGroup } from '../../../../design-system';

const PlaybookMoreOptionsPopup = ({ id, isEditable, openConfirmDeleteModal, onClose }) => {
    const navigate = useNavigate();

    const { toggleViewType } = useViewType();

    const handleNavToPlaybookEditor = () => {
        toggleViewType();

        const link =
            `/playbook/${id}?mode=` +
            (isEditable ? PLAYBOOK_BUILDER_MODE.edit : PLAYBOOK_BUILDER_MODE.view);
        navigate(link);
    };

    const handleAction = (action) => {
        if (!isEditable) return;

        action();
        onClose();
    };

    return (
        <div className="absolute right-0 top-[90%] z-10">
            <ListOptionGroup
                fixedWidth={300}
                listOptions={
                    <>
                        <ListOption
                            leadingIconName="shareBoxLine"
                            text="Go to Playbook Editor"
                            onClick={handleNavToPlaybookEditor}
                        />
                        <ListOption
                            leadingIconName="deleteBin4LineIcon"
                            text="Delete"
                            iconColor="#E95B69"
                            textColor="#E95B69"
                            isDisabled={!isEditable}
                            onClick={() => handleAction(openConfirmDeleteModal)}
                        />
                    </>
                }
                handleClose={onClose}
            />
        </div>
    );
};

export default PlaybookMoreOptionsPopup;
